import tgAxios from "@/api/api-axios";
import { ApiResponse, ListResponse } from "@/types/app.type";
import { DeviceApi, DeviceFormData, DeviceFilter } from "../types/device.type";

export const getDeviceList = (
  params: DeviceFilter
): Promise<ListResponse<DeviceApi>> => {
  const queryString = new URLSearchParams();

  if (params.page) queryString.set("page", params.page.toString());
  if (params.pageSize) queryString.set("pageSize", params.pageSize.toString());
  if (params.name) queryString.set("search", params.name);
  if (params.status && params.status !== "all")
    queryString.set("status", params.status);
  if (params.managerId) queryString.set("managerId", params.managerId);
  if (params.organizationId)
    queryString.set("organizationId", params.organizationId);
  return tgAxios.get(`/devices?${queryString.toString()}`);
};
export const createDevice = (data: DeviceFormData): Promise<DeviceApi> => {
  return tgAxios.post("/devices", data);
};
export const getDeviceById = (id: string): Promise<ApiResponse<DeviceApi>> => {
  return tgAxios.get(`/devices/${id}`);
};
export const updateDevice = (
  id: string,
  data: Partial<DeviceFormData>
): Promise<DeviceApi> => {
  return tgAxios.patch(`/devices/${id}`, data);
};
export const deleteDevice = (id: string): Promise<void> => {
  return tgAxios.delete(`/devices/${id}`);
};

export const updateVolume = async (imei: string, volume: number) => {
  return tgAxios.post(`/mqtt/set-speaker-volume/${imei}`, { volume: volume.toString() });
};
